/* RPM v0.2.3 */
(() => {
  const revealItems = Array.from(document.querySelectorAll('.rpm-reveal'));
  if (!revealItems.length) return;

  // Progressive enhancement: the page is fully visible without JS.
  // Only mark items as animation-ready after this script is successfully running.
  revealItems.forEach((el) => el.classList.add('rpm-reveal--pending'));

  if (!('IntersectionObserver' in window)) {
    revealItems.forEach((el) => {
      el.classList.remove('rpm-reveal--pending');
      el.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -24px 0px' }
  );

  revealItems.forEach((el) => observer.observe(el));

  // Failsafe for Shopify preview/editor or browser states that interrupt observers.
  window.setTimeout(() => {
    revealItems.forEach((el) => el.classList.add('is-visible'));
  }, 1800);
})();
